export default __webpack_public_path__ + "static/media/notification_pink.ecc2c93e.png";